<template>
  <!--
    大图预览组件
    Created by 许松誉 on 2018/11/19.
  -->
  <div class="bigImgBox" v-if="isShowBigImg" v-loading="loading" @click.stop="closeAlert">
    <div class="cont XYcenter" >
      <div class="cont-img" id="contBox" @mousewheel="MouseWheelHandler($event)" @click.stop="closeAlert" :style="{'width':liWidth > 500? liWidth +'px':'500px'}">
        <div class="left-btn colorBB pointer" v-show="isShowProvBtn">
          <i class="el-icon-arrow-left" title="上一张" @click.stop="lastImg" ></i>
        </div>
        <div class="right-btn colorBB pointer" v-show="isShowNextBtn">
          <i class="el-icon-arrow-right" title="下一张" @click.stop="nextImg" ></i>
        </div>

        <ul class="imgbox XYcenter"  @click.stop="">
          <li class="li" :style="{'width': liWidth +'px'}">
            <img v-if="type == 'img'" :src="imgBolbUrl" alt="" class="img" id="bigImg" >
            <pdf v-else :src="pdfUrl" alt="" class="img" id="bigImg" @num-pages="pageCount = $event" @page-loaded="currentPage = $event"  :page="currentPage"></pdf>
          </li> 
        </ul>
        <div class="big-img-close" @click.stop="closeAlert"><i class="el-icon-close"></i></div>
        <div v-if="type == 'pdf' && pageCount !== 1">
          <div class="left-btn colorBB pointer">
            <i class="el-icon-arrow-left" title="上一页" @click.stop="backPage" ></i>
          </div>
          <div class="right-btn colorBB pointer">
            <i class="el-icon-arrow-right" title="下一页" @click.stop="addPage" ></i>
          </div>
          <div style="color:#fff;">{{currentPage}} / {{pageCount}}</div>
        </div>
        <div class="colorBB size12">
          <span style="margin-right:20px;">名称：{{imgName}}</span>
          <span>尺寸：{{widthAndHeight}}</span>
          <span class="info-text">鼠标放在图片上，支持滚轮放大图片</span>
        </div>
        <div class="btn-box" v-show="downloadShow">
          <button class="btn-download-img size12" @click.stop="downloadIamge()">点击下载该图片</button>
        </div>
        </div>
      </div>
    </div>
</template>

<script>

    import pdf from './vue-pdf'
    import CMapReaderFactory from "./vue-pdf/src/CMapReaderFactory.js";
  // import {downLoadFile} from '../../../src/api/imgSpace.js'
    export default {
      props: { // 入参配置
        imgIdList: { // 图片id数组，示例：[{id: 图片id或者采集的url, name: 图片名}]   当id和url都存在时以url优先，若name没有传空字符串
          type: Array,
          default: function () {
            return []
          }
        },
        imgId: { // 选中图片的id或者url
          type: String,
          default: ''
        },
        staticImg: { //是否直接显示
          type:Boolean ,
          default: false
        },
        Leaflet: { //单张显示
          type:Boolean ,
          default: false
        },
      },
      created(){
        let _this = this
      },
      components:{
        pdf
      },
      watch: {
        imgId (n) { // 监听当前选中的图片
          if(n.indexOf('.pdf') == -1){
            this.type = 'img'
          }else{
            this.type = 'pdf'
          }
          let vm = this
          this.imgIdList.map(function (item, index) {
            if (item.id === n) {
              vm.imgIdT = item.id
              vm.imgName = item.name
              if(index == 0){
                vm.isShowProvBtn = false
                vm.isShowNextBtn = true
              }else if(index == vm.imgIdList.length-1){
                vm.isShowProvBtn = true
                vm.isShowNextBtn = false
              }else {
                vm.isShowProvBtn = true
                vm.isShowNextBtn = true
              }
            }
          })
          if(this.imgIdList.length == 1){
            vm.isShowProvBtn = false
            vm.isShowNextBtn = false
          }

        },
        imgIdT (n) { // 监听组件中显示的图片
          this.loading = true
          let vm = this
          setTimeout(function() {
            vm.imgIdList.map(function (item, index) {
              if (item.id === n && vm.imgUrlList[index]) { // 若为之前已经获取过的图片，直接从imgUrlList中获取
                vm.imgBolbUrl = vm.imgUrlList[index]
                vm.loading = false
              } else if  (item.id === n && !vm.imgUrlList[index]) { // 若为还没获取过的图片，需要去获取
                //直接显示static 的图片
                 if (vm.staticImg) {
                  vm.imgBolbUrl = n
                  vm.getImgInfo(vm.imgBolbUrl)
                  vm.imgUrlList[index] = n
                  vm.loading = false
                }else if (n.indexOf('http://') !== -1 || n.indexOf('https://') !== -1) { // 若为url则直接用url显示
                  vm.imgBolbUrl = n
                  vm.getImgInfo(vm.imgBolbUrl)
                  vm.imgUrlList[index] = n
                  vm.loading = false

                }else { // 若为id调用接口获取文件流，然后转文件路径
                  vm.utils.getImgBlob(n , val =>{
                    if(vm.type == 'pdf'){
                      vm.pdfBeforeUrl = val
                      vm.pdfUrl = pdf.createLoadingTask({ url: val, CMapReaderFactory, cMapPacked: true })
                    }else{
                      vm.imgBolbUrl = val
                    }
                    vm.getImgInfo(vm.imgBolbUrl)
                    vm.imgUrlList[index] = val
                    vm.loading = false
                  });
                }
              }
            })
          }, 100)
        },
        imgIdList (n) { // 监听传入的图片id数组
          let vm = this
          vm.imgUrlList = []
          n.map(function (item) {
            vm.imgUrlList.push('')
          })

        },
        imgBolbUrl (n) { // 监听url是否为外链，若为外链隐藏下载按钮
          if(this.type == 'pdf') return  false
          if(this.staticImg){
            this.downloadShow = true
            return
          }
          if (n.indexOf('blob:') !== -1) {
            this.downloadShow = true
          } else {
            this.downloadShow = false
          }
        },
        pdfUrl(n){
          this.downloadShow = true
        },
      },
      data(){
          return {
            currentPage: 1,
            pageCount: null,
            page: 1,
            isShowBigImg: false, // 组件显示控制
            liWidth: 520 , // 大图默认宽度
            imgBolbUrl: '', // 当前显示的大图url路径
            pdfUrl:'',   
            pdfBeforeUrl:'',         
            imgIdT: '', // 当前显示大图的id或者url
            imgName: '', // 当前显示大图的名字
            loading: false, // 组件loading
            imgUrlList: [], // 传入图片的url数组
            widthAndHeight:'100*100', // 当前显示大图的尺寸
            downloadShow: false, // 下载按钮显示，外链url隐藏下载按钮
            isShowProvBtn: true,
            isShowNextBtn: true,
            type:'img'
          }
      },
      methods: {
        show(){
          this.isShowBigImg = true
          if(this.type == 'pdf' && this.imgUrlList.length > 0){
            this.utils.getImgBlob(this.imgId,val =>{
                this.pdfBeforeUrl = val
                this.pdfUrl = pdf.createLoadingTask({ url: val, CMapReaderFactory, cMapPacked: true })
            })
          }
        },
        addPage () { // 翻页+
          if (this.pageCount !== this.currentPage) {
            this.currentPage += 1
          }
        },
        backPage () { // 翻页-
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        },
        lastImg () { // 点击获取上一张图片
          let vm = this
          let imgIdT = this.imgIdT
          this.isShowNextBtn = true
          this.imgIdList.map(function (item, index) {
            if (item.id === imgIdT && index !== 0) {
              vm.imgIdT = vm.imgIdList[index - 1].id
              vm.imgName = vm.imgIdList[index - 1].name
              if(index - 1 == 0)  vm.isShowProvBtn = false
            }
            // else if (item.id === imgIdT && index === 0) {
              // vm.imgIdT = vm.imgIdList[vm.imgIdList.length - 1].id
              // vm.imgName = vm.imgIdList[vm.imgIdList.length - 1].name
            // }
          })
        },
        nextImg () { // 点击获取下一张图片
          let vm = this
          let imgIdT = this.imgIdT
          this.isShowProvBtn = true
          this.imgIdList.map(function (item, index) {
            if (item.id === imgIdT) {
              vm.imgIdT = vm.imgIdList[index + 1].id
              vm.imgName = vm.imgIdList[index + 1].name
              if(Number(index +1) === (vm.imgIdList.length - 1)) vm.isShowNextBtn = false
            }
            // else if (item.id === imgIdT && index === (vm.imgIdList.length - 1)) {

              // vm.imgIdT = vm.imgIdList[0].id
              // vm.imgName = vm.imgIdList[0].name
            // }
          })
        },
        closeAlert(){ // 关闭组件
          this.currentPage = 1
          this.isShowBigImg = false
        },
        downloadIamge() { // 下载图片
          let downurl = this.type == 'img'? this.imgBolbUrl : this.pdfBeforeUrl
          if(downurl){
            this.creatFiled(downurl)
          }else{
            this.$message({
              showClose: true,
              message: '下载失败，请刷新页面',
              type: 'error'
            });
            console.log(error)
          }
        },
        creatFiled(BolbUrl){
          console.log(BolbUrl)
          // 生成一个a元素
          var a = document.createElement('a')
          // 创建一个单击事件
          var event = new MouseEvent('click')
          // 将a的download属性设置为我们想要下载的图片名称
          a.download = this.imgName || '下载图片'
          // 将生成的URL设置为a.href属性
          a.href = BolbUrl
          // 触发a的单击事件
          a.dispatchEvent(event)
        },
        getImgInfo(img_url) { //获取图片尺寸
        　if(this.type == 'img'){
            // 创建对象
            let img = new Image();
            // 改变图片的src
            img.src = img_url;
            let _this = this
            // 加载完成执行
            img.onload = function(){
              // 打印
              _this.widthAndHeight = img.width +'*'+ img.height
              if (img.width > 520) {
                _this.liWidth  = 520
              }
            };
        }else{
          let img = new File([""], '');
          // 改变图片的src
          img.src = img_url;
          // 加载完成执行
          img.onload = function(){
            // 打印
            _this.widthAndHeight = img.width +'*'+ img.height
            if (img.width > 520) {
              _this.liWidth  = 520
            }
          };
        }
        },
        MouseWheelHandler(e) { // 鼠标滑轮滚动放大缩小
          console.log('aaa')
          var e = window.event || e;
          var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
          this.liWidth = this.liWidth + (32 * delta)
          return false;
        }
      }
    }
</script>

<style scoped>
  .cf{zoom:1;}
  .cf:after{content: ''; display: table ;clear: both;}
  .bigImgBox{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(0 , 0, 0, .7);
    z-index: 10001;
    text-align: center;
  }
  .bigImgBox .cont{
    width: 100%;
    height:100%;
    overflow:auto;
    z-index: 4;
  }
  .bigImgBox .cont .btn{
    position:absolute;
    top:50%;
    margin-top:-50px;
    width:30px;
    height:60px;
    background: #fff;
    font-size:40px;
    cursor:pointer;
  }
  .left-btn {
    position:absolute;
    left:0;
    top:50%;
    margin-top: -70px;
    font-size: 50px;
    width: 34px;
    height: 76px;
    background-color: rgba(0, 0, 0, .2);
  }
  .left-btn i{
    position: absolute;
    left: -9px;
    top: 12px;
  }
  .right-btn {
    position:absolute ;
    right:0px;
    top:50%;
    margin-top: -70px;
    font-size: 50px;
    width: 34px;
    height: 76px;
    background-color: rgba(0, 0, 0, .2);
  }
  .right-btn i{
    position: absolute;
    left: -6px;
    top: 12px;
  }
  .left-btn:hover {
    color:#fff;
  }
  .right-btn:hover {
    color:#fff;
  }
  .bigImgBox .imgbox .li{
    width:720px;
    height:100%;
    min-height:200px;
    text-align: center;
  }
  .bigImgBox .imgbox .li img{
    width:100%;
  }
  .bigImgBox .cont-img{
    width:720px;
    position:relative;
    background: transparent;
  }
  .bigImgBox .cont-img .left-arrow {
    position: absolute;
    z-index: 999;
    left: 0;
    top: 40%;
  }
  .bigImgBox .cont-img .left-arrow:hover {
    background: rgba(0 , 0, 0, .3);
  }
  .bigImgBox .cont-img .right-arrow {
    position: absolute;
    z-index: 999;
    right: 0;
    top: 40%;
  }
  .bigImgBox .cont-img .right-arrow:hover {
    background: rgba(0 , 0, 0, .3);
  }
  .bigImgBox .btn-box{
    text-align: center;
    padding: 10px 0 5px;
  }
  .bigImgBox .btn-download-img{
    padding:5px 10px;
    border:1px solid #fff;
    color:#fff;
    border-radius:4px;
    cursor:pointer;
    margin-right:10px;
    vertical-align: middle;
  }
  .bigImgBox .btn-no-margin{
    margin-right:0px;
  }
  .bigImgBox .btn-download-img:hover{
    color:#fff;
    background: #289EFC;
    border:1px solid #289EFC;
  }
  .bigImgBox .info-text{
    font-size:12px;
    line-height: 22px;
    margin-left: 20px;
    display:inline-block
  }
  .file-box{
    vertical-align: middle;
    display: inline-block;
    position: relative;
    padding: 2px 14px;
    overflow: hidden;
    color: #fff;
    background-color: #289EFC;
    border-color: #289EFC;
    width: 74px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border-radius: 3px;
    font-size:14px;
  }
  .file-btn{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    outline: none;
    background-color: transparent;
    filter:alpha(opacity=0);
    -moz-opacity:0;
    -khtml-opacity: 0;
    opacity: 0;
  }
  .bigImgBox .cont::-webkit-scrollbar-track {
    /*滑道*/
    /*-webkit-box-shadow: inset 0 0 6px rgba(187, 187, 187,0.5);*/
    -webkit-box-shadow: inset 0 0 6px rgba(220, 220, 220,0.6);
    /*-webkit-box-shadow: inset 0 0 6px red;*/
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  .bigImgBox .cont::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;

    /*background: rgba(187, 187, 187,0.3);*/
    background: rgba(220, 220, 220,0.4);
    /*background: red;*/
    /*-webkit-box-shadow: inset 0 0 6px rgba(38, 129, 254,0.5);*/
    /*-webkit-box-shadow: inset 0 0 6px rgba(38, 129, 254,0.5);*/
  }
  .bigImgBox .cont::-webkit-scrollbar-thumb:hover {
    /*background: rgba(187, 187, 187,0.5);*/
    /*background: rgba(187, 187, 187,0.5);*/
    background: rgba(220, 220, 220,0.6);
  }
  .bigImgBox /deep/ .el-icon-close {
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 1px;
    color:#fff !important
  }
  .bigImgBox /deep/ .el-icon-close:hover {
    color:#fff !important
  }
  .bigImgBox .big-img-close{
    height: 22px;
    width: 22px;
    position: absolute;
    right: 13px;
    top: 7px;
    font-size: 22px;
    background-color: rgba(0, 0, 0, .2)
  }
  .big-img-close:hover {
    background: #289EFC
  }
</style>



// WEBPACK FOOTER //
// src/components/imageReview.vue